export default "__VITE_PUBLIC_ASSET__7acaef60__"